import { useState } from "react";
import styles from "../../../styles/components/common/nameCopy.module.css";

export default function NameCopy({ it_name }) {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 2000);
    } catch (err) {
      console.error("복사 실패:", err);
    }
  };

  return (
    <>
      <div className={styles.buttonCopy} onClick={() => handleCopy(it_name)}>
        {/* hover 전 */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M10.168 12.25H3.41797C3.21906 12.25 3.02829 12.171 2.88764 12.0303C2.74699 11.8897 2.66797 11.6989 2.66797 11.5V2.75C2.66797 2.55109 2.74699 2.36032 2.88764 2.21967C3.02829 2.07902 3.21906 2 3.41797 2H10.168C10.3669 2 10.5576 2.07902 10.6983 2.21967C10.839 2.36032 10.918 2.55109 10.918 2.75V11.5C10.918 11.6989 10.839 11.8897 10.6983 12.0303C10.5576 12.171 10.3669 12.25 10.168 12.25ZM9.41797 3.5H4.16797V10.75H9.41797V3.5ZM13.168 13.75V5C13.168 4.80109 13.089 4.61032 12.9483 4.46967C12.8076 4.32902 12.6169 4.25 12.418 4.25C12.2191 4.25 12.0283 4.32902 11.8876 4.46967C11.747 4.61032 11.668 4.80109 11.668 5V13H5.66797C5.46906 13 5.27829 13.079 5.13764 13.2197C4.99699 13.3603 4.91797 13.5511 4.91797 13.75C4.91797 13.9489 4.99699 14.1397 5.13764 14.2803C5.27829 14.421 5.46906 14.5 5.66797 14.5H12.418C12.6169 14.5 12.8076 14.421 12.9483 14.2803C13.089 14.1397 13.168 13.9489 13.168 13.75Z"
            fill="#B6BCC9"
          />
        </svg>
      </div>
      <div
        className={
          isCopied
            ? `${styles.buttonCopyTextActive}`
            : `${styles.buttonCopyText}`
        }
      >
        <div className={`${styles.buttonText} label2`}>복사완료</div>
      </div>
    </>
  );
}
